import React, { useMemo } from 'react';
import { ActivityHistoryCard } from '@europrocurement/flexy-components';
import { UtilisateurTaches } from '@europrocurement/l2d-domain';
import { useTheme } from '@mui/material';
import { addTaskIcon } from '@europrocurement/l2d-icons';
import { UseKeycloakService } from '@europrocurement/l2d-keycloak';
import { PrescripteurTachesApiObject } from '@europrocurement/l2d-domain/reducers/tiers/slices/prescripteurTachesSlice';
import { DossierTachesApiObject } from '@europrocurement/l2d-domain/reducers/formalites/slices/dossierTachesSlice';
import TasksCardContent from '../../../../Tasks/components/TasksCardContent/TasksCardContent';
import { useCurrentDossierCtx } from '../../../providers/CurrentDossierProvider';
import { useDossierTasksContext } from '../../../providers/DossierTasksProvider';

const DossierTasksTab: React.FunctionComponent = function () {
    const { palette } = useTheme();
    const { dossier } = useCurrentDossierCtx();

    const keycloakService = UseKeycloakService();
    const userIdentifier = keycloakService.getTokenParsed()?.preferred_username;

    const {
        orderedTasks,
        tasksLoading,
        handleAddTask,
        handleCheckTask,
        handleEditTask,
        handleDeleteTask,
    } = useDossierTasksContext();

    const actions = useMemo(
        () =>
            dossier?.deleted
                ? []
                : [
                      {
                          id: 'add-task',
                          label: 'Ajouter une tâche',
                          shortLabel: 'Ajouter',
                          icon: addTaskIcon,
                          onClick: handleAddTask,
                          variant: 'text' as const,
                          color: palette.grey[700],
                      },
                  ],

        [handleAddTask, palette.grey, dossier?.deleted],
    );

    return (
        <ActivityHistoryCard actions={actions}>
            {dossier && (
                <TasksCardContent
                    tasks={
                        orderedTasks as
                            | DossierTachesApiObject[]
                            | PrescripteurTachesApiObject[]
                            | UtilisateurTaches[]
                    }
                    tasksLoading={tasksLoading}
                    onCheckTask={handleCheckTask}
                    onEditTask={handleEditTask}
                    onDeleteTask={handleDeleteTask}
                    userIdentifier={userIdentifier}
                />
            )}
        </ActivityHistoryCard>
    );
};

export default DossierTasksTab;
